import React from 'react'
import { connect } from 'react-redux'
import { withLDConsumer } from 'launchdarkly-react-client-sdk'

import Loader from 'common/components/loaders/Loader'

import getUserDetails from './sfmc-auth.actions'

class SfmcLoginCallback extends React.Component<any, any> {
  constructor(props) {
    super(props)
    const search = new URLSearchParams(props.location.search)
    const code = search.get('code')
    let tssd = search.get('tssd')

    // SFMC platform v2 tokens embed identifiers inside the JWT `code`. Its
    // `stack_key` (e.g. "S10") is the *stack*, NOT the tenant-specific auth
    // subdomain. If it reaches the backend as `tssd`, the backend builds an
    // invalid auth base URI (https://S10.auth.marketingcloudapis.com) that SFMC
    // rejects with `unauthorized_client`. For v2 we clear `tssd` so the backend
    // falls back to its configured tenant auth endpoint.
    if (code) {
      try {
        const part = code.split('.')[1]
        const base64 = part.replace(/-/g, '+').replace(/_/g, '/')
        const padded = base64.padEnd(
          base64.length + ((4 - (base64.length % 4)) % 4),
          '='
        )
        if (JSON.parse(atob(padded)).platform_version === 2) {
          tssd = null
        }
      } catch {
        // malformed code — leave the tssd from the URL untouched
      }
    }

    this.state = {
      tssd,
      code,
      client: search.get('client'),
    }
  }

  async componentDidMount() {
    const { tssd, code, client } = this.state
    const { getUserDetails: getUserDetailsProps } = this.props
    getUserDetailsProps(tssd, code, client)
    this.checkSfmcUserState()
  }

  componentDidUpdate() {
    this.checkSfmcUserState()
  }

  checkSfmcUserState = () => {
    const { sfmcLoginFailed } = this.props
    /* this is 3 way logic, null on first load and true or false once we get a response from getUserDetails */
    if (sfmcLoginFailed !== null) {
      sfmcLoginFailed ? this.redirectToSignout() : this.redirectToDashboard()
    }
  }

  redirectToDashboard = () => {
    const { flags } = this.props
    const newHomePageFf = flags['showHomePage']
    const { history } = this.props
    newHomePageFf ? history.push('/') : history.push('/dashboard')
  }

  redirectToSignout = () => {
    const { history } = this.props
    history.push('/logout-sso')
  }

  render() {
    return <Loader isFullPage />
  }
}

function mapDispatchToProps(dispatch) {
  return {
    getUserDetails: (tssd, code, client_id) =>
      dispatch(getUserDetails(tssd, code, client_id)),
  }
}
function mapStateToProps(state) {
  return {
    sfmcLoginFailed: state.authStates.sfmcLoginFailed,
  }
}

const ConnectedComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(SfmcLoginCallback)

// We want to retrieve the flags from Dark Launch so set it to false
const ldConsumerOptions = {
  clientOnly: false,
}

const SfmcLoginCallbackWithLDConsumer =
  withLDConsumer(ldConsumerOptions)(ConnectedComponent)

export default SfmcLoginCallbackWithLDConsumer
